const indexItems = [
  { letter: 'A', items: '爱情公寓、暗算、暗夜行者' },
  { letter: 'B', items: '白夜追凶、冰与火之歌、变形金刚' },
  { letter: 'C', items: '长津湖、超时空同居、沉默的真相' },
  { letter: 'D', items: '大江大河、盗梦空间、都挺好' },
  { letter: 'F', items: '飞驰人生、风声、父母爱情' },
  { letter: 'H', items: '哈利波特、红海行动、欢乐颂' },
  { letter: 'J', items: '觉醒年代、教父、寄生虫' },
  { letter: 'L', items: '流浪地球、琅琊榜、猎罪图鉴' },
  { letter: 'S', items: '三体、少年的你、山河令' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">剧集索引</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">按字母快速查找你想看的影视作品</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((group) => (
            <a
              key={group.letter}
              href="#cards"
              className="block bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-accent-300 transition-colors cursor-pointer group"
            >
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg md:text-xl flex-shrink-0">
                  {group.letter}
                </span>
                <div className="min-w-0">
                  <p className="text-sm text-foreground-700 leading-relaxed group-hover:text-primary-600 transition-colors">{group.items}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="text-center mt-6">
          <p className="text-xs text-foreground-500">更多字母索引持续完善中，热门影视陆续收录</p>
        </div>
      </div>
    </section>
  );
}